import { DITypes } from "@/core/@types/types";
import type { IF360Date } from "./date/F360Date";
import { diContainer } from "@/core/di";

export default function useDate() {
  const dateLib = diContainer.get<IF360Date>(DITypes.DATE);

  return dateLib;
}
